export default (value) => {
  let testValue = parseFloat(value.replace('$', '').replace(',', ''));
  if (testValue > 0) {
    return '+' + value;
  }
  return value;
};